import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

const currentThemeTypeSelector = (state: AppState) => state.theme.type;
export const useCurrentThemeTypeSelector = () => useSelector(currentThemeTypeSelector);

const currentThemeSelector = (state: AppState) => state.theme;
export const useCurrentThemeSelector = () => useSelector(currentThemeSelector);
